import { render, staticRenderFns } from "./IconUndo.vue?vue&type=template&id=4c972d2a&"
import script from "./IconUndo.vue?vue&type=script&lang=js&"
export * from "./IconUndo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c972d2a')) {
      api.createRecord('4c972d2a', component.options)
    } else {
      api.reload('4c972d2a', component.options)
    }
    module.hot.accept("./IconUndo.vue?vue&type=template&id=4c972d2a&", function () {
      api.rerender('4c972d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconUndo.vue"
export default component.exports